<template></template>

<script setup lang="ts">
  import { FilterMatchMode } from "primevue/api";
  import { defineColumnFilter, defineColumnProps } from "../../lib/defines";

  defineExpose(
    Object.assign(
      {},
      defineColumnProps({
        showFilterMatchModes: false,
        showApplyButton: false,
        showClearButton: false,
      }),
      defineColumnFilter({
        matchMode: FilterMatchMode.EQUALS,
      }),
    ),
  );
</script>
